/**
 * 拼单购物车顶部模块
 */
import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { orderMobx } from 'restaurant'
import { advertMobx, buyTogetherMobx, multiPersonMobx, decorationMobx } from '@mobxStore'
import { handleShareForWxa } from '@common/utils/share'
import { Icon, Advert as MenuAdvert } from '@cps'
import './index.scss'

interface IProps {
  handleOutCart: () => void;
}

const defaultImg = 'http://eshine-image.oss-cn-hangzhou.aliyuncs.com/product/7178bc33e9c44bdaba2f1e21db128acb.png'

const Btcart: React.FC<IProps> = (props) => {
  const { handleOutCart } = props
  const key = 'buyTogether'
  const { availableAdsMap } = advertMobx
  const { globalDecorates } = decorationMobx
  const { order } = orderMobx

  const handleShare = () => {
    if (buyTogetherMobx.checkNotAuthAvatarCanBT) return
    const router = `${location.origin}/buyTogetherCart?ct=brand&b=${Config.BRANDID}&s=${Config.STOREID}&bt=${Config.buyTogetherId}`
    handleShareForWxa({ mode: 'card', scene: 'buyTogether', router, title: globalDecorates.btTxt || `${multiPersonMobx.multiPersonMap[buyTogetherMobx.getOwner]?.nickName}邀请你一起点`, imageUrl: globalDecorates.btImg?.url || defaultImg, isHref: true, jumpH5Page: router })
  }
  return (
    <div className='btcart-top-container'>
      {
        order.ordersId ? (
          <p className='btcart-title'>{i18n.t(`menu.buyTogetherTip.${multiPersonMobx.currentPersonInfo.isOwner ? 'owenrPaying' : 'otherPaying'}`)}{}</p>
        ) : (
          <div className='btcart-top-wrapper'>
            <div className='btcart-advert-wrapper'>
              {availableAdsMap?.[key]?.length ? <MenuAdvert type={key} /> : <img src={defaultImg} />}
            </div>
            <div className='close-btn-wrapper' data-cypid='out-bt-cart' onClick={handleOutCart}>
              <Icon name='zhuye' />
            </div>
            <div className='share-btn-wrapper'>
              <button className='btn confirm' data-cypid='share-bt-cart' onClick={handleShare}>{i18n.t('menu.buyTogether.inviteFriends')}</button>
            </div>
          </div>
        )
      }
    </div>
  )
}

export default observer(Btcart)
